import { getBotLevel, getBotLevelTextKey } from "../models/Bot";

const GUEST_USERNAME_PREFIX = "guest-";

// Name to show for a player, or undefined if the server sent none (legacy userKey players).
// Guests show as e.g. "Guest 4F2A" instead of their generated username, the bot as e.g. "Bot · Medium".
export function getPlayerDisplayName(
    player: { userId?: string, name?: string, isGuest?: boolean } | undefined,
    t: (key: string) => string
): string | undefined {
    const botLevel = getBotLevel(player?.userId);
    if (botLevel) return `${t("Bot")} · ${t(getBotLevelTextKey(botLevel))}`;
    if (!player?.name) return undefined;
    if (player.isGuest) {
        const suffix = player.name.startsWith(GUEST_USERNAME_PREFIX) ? player.name.slice(GUEST_USERNAME_PREFIX.length) : player.name;
        return `${t("Guest")} ${suffix.slice(0, 4).toUpperCase()}`;
    }
    return player.name;
}
